// TODO: If there are similar views to this coming up, abstract this out as a template and pass
// content in
import Title from 'components/ui-components/Title';

const SubmissionFail = () => (
  <div className="margin-center l-width-60">
    <Title icon="error" title="Registration Unsuccessful" />

    <div className="mt-10 m-mt-20 ta-c">
      <p className="fs-18 lh-1-4 fw-400 tc-secondary">
        Sorry, we are unable to complete your application at present. Your
        details have been passed onto our Account Creation team. If you would
        like more information, please contact our customer services team on{' '}
        <a className="td-u" href="tel:+441763272717">
          01763 272 717
        </a>{' '}
        or{' '}
        <a className="td-u" href="mailto:customerservices@cef.co.uk">
          customerservices@cef.co.uk
        </a>
      </p>

      <a className="cef-btn cef-btn--feature cef-btn--grey mt-20" href="/">
        Back to Home
      </a>
    </div>
  </div>
);

export default SubmissionFail;
